import { STATUS, TeamAthlete } from '@type/db-types';
import {
    CircularProgress,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tooltip,
    Typography,
} from '@mui/material';
import { updateTeamStatus } from '@modules/supabase/teams';
import useUser from '@hooks/useUser';
import { useState } from 'react';
import { statusKeyToLabel } from '@utils/team-table-utils';

interface Props {
    refresh?: () => void;
    user: Pick<TeamAthlete, 'id' | 'membershipId' | 'teamStatus'>;
}

export default function TeamStatusSelector({ refresh, user }: Props) {
    const currentUser = useUser();
    const { membershipId, teamStatus } = user;
    const [loading, setLoading] = useState(false);

    const handleChange = async ({ target: { value: status } }: SelectChangeEvent) => {
        if (!membershipId) return;

        setLoading(true);
        await updateTeamStatus(status as STATUS, membershipId);

        // invalidate local user data & refetch
        refresh?.();
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    if (!user) return null;

    // Prevent admins from demoting themselves and breaking their setup
    if (currentUser.user?.id === user.id)
        // <div>
        return (
            <Tooltip title={'You cannot change your own status'}>
                <Typography variant="body2">{statusKeyToLabel(teamStatus)} (You)</Typography>
            </Tooltip>
        );

    return (
        <Select
            size="small"
            onChange={handleChange}
            value={teamStatus}
            sx={{ paddingBottom: '0rem' }}
        >
            {Object.values(STATUS).map((value) => (
                <MenuItem key={value} value={value} sx={{ paddingBottom: '0rem' }}>
                    <Typography variant="body2">{statusKeyToLabel(value)}</Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
